// SPDX-FileCopyrightText: 2026 Igor Brkic <igor@hyperglitch.com>
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Entry point. Everything else is built from here.
 */

import { App } from './app.ts';
import { BRAND } from './brand.ts';

const root = document.getElementById('app');
if (root === null) throw new Error('missing #app');

document.title = `${BRAND.short} — ${BRAND.titleTagline}`;
new App(root);
